__turbopack_context__.v({
  "card-content": "RegistrationSideCard-module-scss-module__67xCEa__card-content",
  "container": "RegistrationSideCard-module-scss-module__67xCEa__container",
  "el-product": "RegistrationSideCard-module-scss-module__67xCEa__el-product",
  "fixed-product-price": "RegistrationSideCard-module-scss-module__67xCEa__fixed-product-price",
  "gas-product": "RegistrationSideCard-module-scss-module__67xCEa__gas-product",
  "location": "RegistrationSideCard-module-scss-module__67xCEa__location",
  "over-capacity": "RegistrationSideCard-module-scss-module__67xCEa__over-capacity",
  "personal-instalment": "RegistrationSideCard-module-scss-module__67xCEa__personal-instalment",
  "price": "RegistrationSideCard-module-scss-module__67xCEa__price",
  "price-explanation": "RegistrationSideCard-module-scss-module__67xCEa__price-explanation",
  "producer": "RegistrationSideCard-module-scss-module__67xCEa__producer",
  "promo": "RegistrationSideCard-module-scss-module__67xCEa__promo",
  "promo-line": "RegistrationSideCard-module-scss-module__67xCEa__promo-line",
  "secondary": "RegistrationSideCard-module-scss-module__67xCEa__secondary",
  "section": "RegistrationSideCard-module-scss-module__67xCEa__section",
  "section-header": "RegistrationSideCard-module-scss-module__67xCEa__section-header",
  "section-title": "RegistrationSideCard-module-scss-module__67xCEa__section-title",
  "selected-producer": "RegistrationSideCard-module-scss-module__67xCEa__selected-producer",
  "simulation": "RegistrationSideCard-module-scss-module__67xCEa__simulation",
  "simulation-actions": "RegistrationSideCard-module-scss-module__67xCEa__simulation-actions",
  "tooltip-icon": "RegistrationSideCard-module-scss-module__67xCEa__tooltip-icon",
  "usage": "RegistrationSideCard-module-scss-module__67xCEa__usage",
  "usage-badges": "RegistrationSideCard-module-scss-module__67xCEa__usage-badges",
});
